import React, { useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useAffiliateAuth } from "../../contexts/AffiliateAuthContext";
import { Lock, ShieldCheck, AlertCircle, TrainFront } from "lucide-react";

export default function AffiliateLogin() {
  const { login, token } = useAffiliateAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (token) return <Navigate to={location.state?.from || "/affiliate"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
    } catch (er) {
      setErr(er?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F1B2E] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="flex items-center gap-3 justify-center mb-6">
          <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center">
            <TrainFront className="w-6 h-6 text-[#0F1B2E]" strokeWidth={2.4} />
          </div>
          <div className="text-white">
            <p className="font-extrabold leading-none">Referral Partner Portal</p>
            <p className="text-[11px] uppercase tracking-widest text-slate-400">Train Driver Foundation</p>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-xl p-7 space-y-4">
          <div className="flex items-center gap-2 text-[#E63B2E]">
            <ShieldCheck className="w-5 h-5" />
            <h1 className="tdf-heading text-xl text-tdf-navy">Referral Partner sign in</h1>
          </div>
          <p className="text-sm text-slate-500">Sign in to view your referral link, commission and payout history.</p>
          <div>
            <label className="block text-sm font-bold text-tdf-navy mb-1.5">Email</label>
            <input
              type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-slate-300 focus:border-[#E63B2E] focus:ring-2 focus:ring-[#E63B2E]/20 outline-none px-4 py-2.5"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-sm font-bold text-tdf-navy mb-1.5">Password</label>
            <div className="relative">
              <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-lg border border-slate-300 focus:border-[#E63B2E] focus:ring-2 focus:ring-[#E63B2E]/20 outline-none pl-10 pr-4 py-2.5"
              />
            </div>
          </div>
          {err && (
            <div className="flex items-start gap-2 bg-rose-50 border border-rose-200 text-rose-800 rounded-lg p-3 text-sm">
              <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" /> {err}
            </div>
          )}
          <button type="submit" disabled={loading} className="w-full btn-pill btn-primary disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-xs text-slate-400 text-center pt-1">
            The Referral Partner Programme is invite-only. If you've been invited, use the link in your invite
            email to accept it, or the details below to sign in.
          </p>
        </form>
        <p className="text-center mt-5">
          <Link to="/referral-programme" className="text-xs text-slate-400 hover:text-white">
            ← Learn more about the Referral Partner Programme
          </Link>
        </p>
      </div>
    </div>
  );
}
